import React from 'react'
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import { withRouter } from 'react-router-dom'

function Menu_Rodape() {
  return (
    <Grid container sx={{ bgcolor: '#EAFAF1', padding: '5px' }}>

      <Grid item xs={12} md={4} inline variant="body1" align="left" paddingLeft={'20px'}>
        <Link href='/minha_conta'>Minha Conta</Link>
      </Grid>

      <Grid item xs={12} md={4} inline variant="body1" align="left" paddingLeft={'20px'}>
        <Link href='/privacidade'>Política de Privacidade</Link>
      </Grid>

      <Grid item xs={12} md={4} inline variant="body1" align="left" paddingLeft={'20px'}>
        <Link href='/faturado'>Clientes Faturados</Link>
      </Grid>

      <Grid item xs={12} md={4} inline variant="body1" align="left" paddingLeft={'20px'}>
        <Link href='/meus_pedidos'>Meus Pedidos</Link>
      </Grid>

      <Grid item xs={12} md={4} inline variant="body1" align="left" paddingLeft={'20px'}>
        <Link href='#'>Política de Cookies</Link>
      </Grid>

      <Grid item xs={12} md={4} inline variant="body1" align="left" paddingLeft={'20px'}>
        <Link href='/como_pesquisar_produtos'>Como Pesquisar Produtos</Link>
      </Grid>

      <Grid item xs={12} md={4} inline variant="body1" align="left" paddingLeft={'20px'}>
        <Link href='#'>Trocas & Devoluções</Link>
      </Grid>

      <Grid item xs={12} md={4} inline variant="body1" align="left" paddingLeft={'20px'}>
        <Link href='/frete_gratis'>Frete e Delivery</Link>
      </Grid>

      <Grid item xs={12} md={4} inline variant="body1" align="left" paddingLeft={'20px'}>
        <Link href='/lojas_fisicas'>Lojas Físicas NAFIL</Link>
      </Grid>

      <Grid item xs={12} md={4} inline variant="body1" align="left" paddingLeft={'20px'}>
        <Link href='#'>Garantias</Link>
      </Grid>

      <Grid item xs={12} md={4} inline variant="body1" align="left" paddingLeft={'20px'}>
        <Link href='#'>Trabalhe Conosco</Link>
      </Grid>

    </Grid>
  )
}

export default withRouter(Menu_Rodape)